import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type DefaultMatterFileRepositoryStructureFolder,
} from "@/lib/types";

export const retrieveDefaultMatterFileRepositoryStructureFolderV1 = (
  id: string,
) => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<DefaultMatterFileRepositoryStructureFolder[]>
    >(`${baseFastApiMatterRoute}/default-matter-file-repository-structures/${id}/folders`)
    .then((res) => res.data);
};

export const createDefaultMatterFileRepositoryStructureFolderV1 = (
  data: Pick<
    DefaultMatterFileRepositoryStructureFolder,
    "name" | "structureId" | "idLocation"
  > &
    Partial<DefaultMatterFileRepositoryStructureFolder>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<DefaultMatterFileRepositoryStructureFolder>
    >(`${baseFastApiMatterRoute}/default-matter-file-repository-structures/folders`, data)
    .then((res) => res.data);
};

export const deleteDefaultMatterFileRepositoryStructureFolderV1 = (
  data: Pick<DefaultMatterFileRepositoryStructureFolder, "id" | "structureId">,
) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<DefaultMatterFileRepositoryStructureFolder>
    >(`${baseFastApiMatterRoute}/default-matter-file-repository-structures/${data.structureId}/folders/${data.id}`)
    .then((res) => res.data);
};
